let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5Gah6")).then(() => parcelRequire('jq88S'));